import React, { Component } from 'react';
import UserData from '../components/UserData';
import { ToastContainer, toast } from 'react-toastify';
import { getUserId, getUser, saveUserData } from '../service/UserService';
import ClipLoader from "react-spinners/ClipLoader";

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            userData: null
        }
    }

    componentDidMount(){
        let userId = getUserId();
        getUser(userId).then((responseJson)=>{
            //console.log("response:", responseJson);
            this.setState({userData: responseJson});
        });
    }

    handleSubmitClick(values){
        //toast("Felhasználói adatok mentése");
        saveUserData(values).then((result) => {
            //console.log("result", result);
            if(!result) return;
            if(result.data.status === true){
                toast("Felhasználói adatok mentve", {type:'info'});
            }
            else{
                alert("error: " + result.data.message);
            } 
        });
    }

    render() { 
        return (
            <div style={{paddingBottom:30}}>
                <h2 className="kwizda-page-title">Személyes adatok módosítása</h2>
                {this.state.userData && 
                    <UserData userData={this.state.userData} 
                        handleSubmitClick={(values) => this.handleSubmitClick(values)}>
                    </UserData>}
                <ToastContainer />
                <ClipLoader loading={!this.state.userData} size={80} />
            </div>

        );
    }
}
 
export default Profile;